import axios from "axios";
import { getAccessToken } from "./helpers";
import { mysphereAPIURL } from "../app/auth/util/CustomConstants";

export const generateAssessment = async (data) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
    };

    return await axios.post(
        `${mysphereAPIURL}/api/v1/ai/generate-assessment`,
        data,
        { headers }
    );
}

export const listAssessment = async () => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
    };
    return await axios.get(
        `${mysphereAPIURL}/api/v1/assessment/list`,
        { headers }
    );
}

export const deleteAssessment = async (id) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
    };
    return await axios.delete(
        `${mysphereAPIURL}/api/v1/assessment/delete/${id}`,
        { headers }
    );
}

export const updateAssessment = async (assessmentId, data) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
    };

    return await axios.put(
        `${mysphereAPIURL}/api/v1/assessment/org-cohort-assessment/${assessmentId}`,
        data,
        { headers }
    );
}

export const generateAssessmentQuestions = async (assessmentId, data) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
    };

    return await axios.post(
        `${mysphereAPIURL}/api/v1/assessment/org-cohort-assessment/${assessmentId}/generate-questions`,
        data,
        { headers }
    );
}

export const generateAssessmentForCohort = async (data) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
    };

    return await axios.post(
        `${mysphereAPIURL}/api/v1/ai/cohort-content-assessment`,
        data,
        { headers }
    );
}

export const listCohortAssessments = async (cohortId, contentId) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
    };

    return await axios.get(
        `${mysphereAPIURL}/api/v1/assessment/org-cohort-assessment/list?cohortId=${cohortId}&contentId=${contentId}&userAiChats=true`,
        { headers }
    );
}

export const listCohortDirectAssessments = async (cohortId) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
    };

    return await axios.get(
        `${mysphereAPIURL}/api/v1/assessment/org-cohort-direct-assessment/list?cohortId=${cohortId}`,
        { headers }
    );
}

export const listCohortDirectAssessment = async (cohortId, contentId) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
    };

    return await axios.get(
        `${mysphereAPIURL}/api/v1/assessment/org-cohort-assessment/list?cohortId=${cohortId}&contentId=${contentId}&userAiChats=true&directAssessments=true`,
        { headers }
    );
}

export const uploadDirectAssessmentForCohort = async (data) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`,
    };

    return await axios.post(
        `${mysphereAPIURL}/api/v1/assessment/upload`,
        data,
        { headers }
    );
}

export const generateLectureForCohort = async (data) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
    };

    return await axios.post(
        `${mysphereAPIURL}/api/v1/ai/cohort-content-lecture`,
        data,
        { headers }
    );
}

export const listCohortLectures = async (data) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
    };

    return await axios.post(
        `${mysphereAPIURL}/api/v1/ai/list-lectures`,
        data,
        { headers }
    );
}

export const deleteLecture = async (id) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
    };
    return await axios.delete(
        `${mysphereAPIURL}/api/v1/ai/delete-lecture/${id}`,
        { headers }
    );
}

export const saveAndRegenerateLecture = async (id, data) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
    };

    return await axios.post(
        `${mysphereAPIURL}/api/v1/ai/lecture/${id}/save-and-regenerate`,
        data,
        { headers }
    );
};

export const generateImageForLecture = async (data) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
    };

    return await axios.post(
        `${mysphereAPIURL}/api/v1/ai/lecture/generate-image`,
        data,
        { headers }
    );
};